export type OrderVersionPreference = 'auto' | 'v1' | 'v2';

export type OrderVersionUsed = 'v1' | 'v2';

export const ORDER_VERSION_PREFERENCE_STORAGE_KEY = 'orderVersionPreference';

export const ORDER_VERSION_PREFERENCE_HEADER = 'X-Order-Version-Preference';

export const ORDER_VERSION_PREFERENCE_OPTIONS: OrderVersionPreference[] = [
    'auto',
    'v1',
    'v2',
];
